import { render, staticRenderFns } from "./service-provider-list.vue?vue&type=template&id=61660c79&scoped=true"
import script from "./service-provider-list.vue?vue&type=script&lang=js"
export * from "./service-provider-list.vue?vue&type=script&lang=js"
import style0 from "./service-provider-list.vue?vue&type=style&index=0&id=61660c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61660c79",
  null
  
)

export default component.exports